import React from 'react';
import { X, Plus } from 'lucide-react';

const FileTabs = ({
  files,
  activeFile,
  onActiveFileChange,
  isDarkMode = false,
}) => {
  const fileNames = Object.keys(files);

  if (fileNames.length === 0) {
    return null;
  }

  return (
    <div
      className={`flex items-center space-x-1 px-3 py-2 border-b overflow-x-auto ${
        isDarkMode
          ? 'bg-gray-800 border-gray-700'
          : 'bg-gray-100 border-gray-300'
      }`}
    >
      {fileNames.map((fileName) => (
        <button
          key={fileName}
          onClick={() => onActiveFileChange(fileName)}
          className={`flex items-center space-x-2 px-3 py-1 rounded-t transition-colors whitespace-nowrap text-sm font-medium ${
            activeFile === fileName
              ? isDarkMode
                ? 'bg-[#4B1498] text-white border-b-2 border-[#A66FFF]'
                : 'bg-[#F0EBFF] text-[#191F2D] border-b-2 border-[#A66FFF]'
              : isDarkMode
              ? 'bg-gray-900 text-gray-400 hover:text-gray-200 hover:bg-gray-800'
              : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
          }`}
        >
          <span className="max-w-xs truncate">{fileName}</span>
        </button>
      ))}
    </div>
  );
};

export default FileTabs;
